module.exports = __webpack_public_path__ + "49276d972e445b4e254386d099fba7fd.png";